import { Component, HostBinding, Inject, Input, OnChanges } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Decimal } from 'decimal.js';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { BetslipType } from '../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../betplacement/models';
import { IResultSucceededSlipSummaryViewModel } from '../../models/result-succeeded-slip.model';
import { UsedTokenPayoutSummaryService } from '../../services/used-token-payout-summary.service';

@Component({
    selector: 'bs-digital-result-succeeded-teaser-slip',
    templateUrl: './result-succeeded-teaser-slip.component.html',
    styleUrls: ['./result-succeeded-teaser-slip.component.scss'],
    standalone: false,
})
export class ResultSucceededTeaserSlipComponent implements OnChanges {
    @Input() slip: ISucceededSlipResult;
    @Input() tokenPayoutSummary?: string;
    @Input() showSummary: boolean;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() teasedPoints: number;
    @HostBinding('class') className = 'betslip-result-succeeded-slip';
    summaryViewModel: IResultSucceededSlipSummaryViewModel;

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) private messagesProvider: IBetslipMessagesProviderService,
        private usedTokenPayoutSummaryService: UsedTokenPayoutSummaryService,
    ) {}

    ngOnChanges(): void {
        this.summaryViewModel = this.getSummaryViewModel(this.slip);
    }

    get isSingleBetPick(): boolean {
        return this.slip.picks.length === 1;
    }

    private getSummaryViewModel(slip: ISucceededSlipResult): IResultSucceededSlipSummaryViewModel {
        const messages = this.messagesProvider.getMessages().result;
        const totalStake = slip.totalStake;
        const stakePerBet = slip.stake;
        const possibleWinningsGross = slip.possibleWinnings?.gross ?? 0;
        const possibleWinningsNet = slip.possibleWinnings?.net ?? 0;
        const taxation = possibleWinningsGross - possibleWinningsNet;
        const viewModel: IResultSucceededSlipSummaryViewModel = {
            betType: BetslipType.Combo,
            stakePerBet,
            stake: totalStake,
            possibleWinnings: {
                title: taxation > 0 ? messages.possibleWinningsNet : messages.possibleWinnings,
                value: new Decimal(possibleWinningsGross - taxation),
            },
            rewardTokenInfo: undefined,
        };

        if (slip.picks.length > 1 && slip.totalOdds) {
            // Multi pick bet
            viewModel.odds = {
                title: messages.totalOdds,
                value: slip.totalOdds,
            };
        }

        return this.usedTokenPayoutSummaryService.getViewModelWithTokenInfo(slip, viewModel);
    }
}
